import Spinner from './Spinner';
import FullPageSpinner from './FullPageSpinner';

export { FullPageSpinner };

export default Spinner;
